module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundBig.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundBig.png
// module id = 246
// module chunks = 0